class GatherTab {
  options = {
    selectors: {
      eventTypeSelector: '.js-booking-event-type',
      eventPropertySelector: '.js-booking-event-property',
      wrapper: '.js-gather-tab',
      hideForRFP: ['.js-hide', '.wpcf7-response-output', '.cf-turnstile'],
      RFPactionsSelector: '.js-gather-speedrfp',
      RFPbuttonSelector: '.js-gather-speedrfp-button',
      formGroup: '.booking-widget__form-group',
      stayVisibleClass: '.js-booking-gather-both-cases',
      turnstile: '.cf-turnstile',
    },
    showSpeedRFPValue: 'meetings',
    speedRFPConfig: {
      properties: {},
    },
  };

  constructor() {
    if (typeof speedrfp === 'undefined') {
      return;
    }

    this.eventType = document.querySelector(this.options.selectors.eventTypeSelector);
    this.eventProperty = document.querySelector(this.options.selectors.eventPropertySelector);
    this.speedRFPButton = document.querySelector(this.options.selectors.RFPbuttonSelector);
    this.gatherWrapper = document.querySelector(this.options.selectors.wrapper);
    // eslint-disable-next-line no-undef
    this.options.speedRFPConfig.properties = speedrfp || {};
    // eslint-disable-next-line no-undef
    this.options.currentHotelId = currentHotelId || null;
    this.shouldRestoreAfterClose = false;
    this.mailSentHandler = this.#handleMailSent.bind(this);
    this.closeClickHandler = this.#handleCloseClick.bind(this);
    this.overlayHideHandler = this.#handleOverlayHide.bind(this);

    if (this.gatherWrapper) {
      this.gatherWrapper.addEventListener('wpcf7mailsent', this.mailSentHandler);
    }

    document.addEventListener('click', this.closeClickHandler);
    document.body.addEventListener('overlay:hide', this.overlayHideHandler);
    this.initSpeedRFP();
  }

  initSpeedRFP() {
    document.addEventListener('DOMContentLoaded', () => {
      if (!this.gatherWrapper) {
        return;
      }

      const formElement = this.gatherWrapper.querySelector('form');
      if (!formElement) {
        return;
      }

      this.gatherForm = formElement;
      this.gatherForm.setAttribute('autocomplete', 'off');
      this.gatherForm.reset();
      this.eventType.addEventListener('change', this.handleChanges.bind(this));
      this.eventProperty.addEventListener('change', this.handleChanges.bind(this));
      this.eventType.value = this.#findSelectedOption();
      this.eventType.dispatchEvent(new Event('change'));

      // set current hotel as selected
      if (this.eventProperty && this.options.currentHotelId) {
        this.eventProperty.value = this.options.currentHotelId;
      }

      if (this.eventProperty.value == 10929 && document.body.classList.contains('main-site')) {
        this.eventProperty.value = '';
      }

      if (this.speedRFPButton) {
        this.speedRFPButton.addEventListener('click', (speedRFPevent) => {
          speedRFPevent.preventDefault();
          // eslint-disable-next-line max-len
          const currentProperty = this.options.speedRFPConfig.properties[this.eventProperty.value] || null;

          if (currentProperty) {
            const redirectUrl = currentProperty?.redirect_link?.url;
            if (redirectUrl) {
              window.open(redirectUrl, '_blank').focus();
            } else {
              window.speedRFPWidget.show();
            }
          } else {
            console.warn(`No speedrfp config for property ${this.eventProperty.value}`);
          }
        });
      }

      // Hide from list "The Capitana,The Laureate,Treasure Island Beach Resort"
      const shouldBeHiddenFromList = [10948, 10949, 10952];
      // eslint-disable-next-line
      shouldBeHiddenFromList.map((el) => {
        const optionToHide = this.eventProperty.querySelector(`[value="${el}`);
        if (optionToHide) {
          optionToHide.remove();
        }
      });
    });
  }

  handleChanges() {
    // eslint-disable-next-line max-len
    const currentProperty = this.options.speedRFPConfig.properties[this.eventProperty.value] || null;
    // eslint-disable-next-line max-len
    const speedRPFavailable = (currentProperty && ((currentProperty.code && currentProperty.form_key) || (currentProperty.redirect_link)));

    // check if it makes sense at all
    const typeValue = this.eventType.value.toLowerCase();
    const shouldUseSpeedRFP = speedRPFavailable && (typeValue === this.options.showSpeedRFPValue);

    const elementsToToggle = [
      ...this.options.selectors.hideForRFP,
      this.options.selectors.formGroup,
    ];

    elementsToToggle.forEach((selector) => {
      const elements = document.querySelectorAll(
        `${this.options.selectors.wrapper} ${selector}:not(${this.options.selectors.stayVisibleClass})`,
      );

      elements.forEach((el) => {
        el.classList.toggle('booking-widget__hidden', shouldUseSpeedRFP);
      });
    });

    const rfpActions = document.querySelector(
      `${this.options.selectors.wrapper} ${this.options.selectors.RFPactionsSelector}`,
    );

    if (rfpActions) {
      rfpActions.classList.toggle('booking-widget__hidden', !shouldUseSpeedRFP);
    }
  }

  #findSelectedOption() {
    let { value } = this.eventType;
    Array.from(this.eventType.options).forEach((element) => {
      // eslint-disable-next-line
      if (location.href.indexOf(element.value.toLowerCase()) !== -1) {
        value = element.value;
      }
    });

    return value;
  }

  #handleMailSent(event) {
    if (!this.gatherWrapper) {
      return;
    }

    const form = event.target;
    if (!form) {
      return;
    }

    this.gatherForm = form;
    const fieldsets = form.querySelectorAll('.booking-widget__fieldset');
    const outputMessage = this.gatherWrapper.querySelector('.wpcf7-response-output');
    const shouldHideFieldsets = this.#isBrandVenuesFlow() && fieldsets.length > 0;

    if (shouldHideFieldsets) {
      fieldsets.forEach((fieldset) => {
        fieldset.classList.add('booking-widget__hidden');
      });
    } else {
      // Legacy behavior for non-brand flows: remove elements
      fieldsets.forEach((fieldset) => fieldset.remove());
    }

    // CF7 prepends the Turnstile widget outside the fieldsets and resets it
    // on wpcf7submit, so it would stay above the success message.
    form.querySelector(this.options.selectors.turnstile)?.classList.add('booking-widget__hidden');

    if (outputMessage) {
      outputMessage.classList.add('custom-gather');
      outputMessage.style.display = '';
      outputMessage.removeAttribute('aria-hidden');
    }

    this.shouldRestoreAfterClose = shouldHideFieldsets;
  }

  #handleCloseClick(event) {
    if (!event.target.closest('.booking-widget__close .c-cross')) {
      return;
    }

    this.#handleWidgetClosed();
  }

  #restoreGatherForm() {
    if (!this.gatherWrapper) {
      return;
    }

    const form = this.gatherForm || this.gatherWrapper.querySelector('form');
    // Find hidden fieldsets
    const hiddenFieldsets = form ? form.querySelectorAll('.booking-widget__fieldset.booking-widget__hidden') : [];

    if (!form || hiddenFieldsets.length === 0) {
      this.#clearBrandVenueState();
      return;
    }

    // Show fieldsets back
    hiddenFieldsets.forEach((fieldset) => {
      fieldset.classList.remove('booking-widget__hidden');
    });

    form.querySelector(this.options.selectors.turnstile)?.classList.remove('booking-widget__hidden');

    form.reset();

    const responseOutput = this.gatherWrapper.querySelector('.wpcf7-response-output');
    if (responseOutput) {
      responseOutput.classList.remove('custom-gather');
      responseOutput.textContent = '';
      responseOutput.style.display = 'none';
      responseOutput.setAttribute('aria-hidden', 'true');
    }

    const formWrapper = this.gatherWrapper.querySelector('.wpcf7');
    formWrapper?.classList.remove('sent');
    form.classList.remove('sent');

    this.shouldRestoreAfterClose = false;
    this.#clearBrandVenueState();
  }

  #handleOverlayHide() {
    this.#handleWidgetClosed();
  }

  #handleWidgetClosed() {
    if (this.shouldRestoreAfterClose) {
      this.#restoreGatherForm();
      return;
    }

    this.#clearBrandVenueState();
  }

  #isBrandVenuesFlow() {
    return this.gatherWrapper?.dataset?.brandVenuesRfp === 'true';
  }

  #clearBrandVenueState() {
    if (this.gatherWrapper?.dataset) {
      this.gatherWrapper.dataset.brandVenuesRfp = 'false';
    }
  }
}

export default GatherTab;
